import {useState} from 'react';

export function useAutoCollapse(
  confirmedCount: number,
  totalCount: number,
  forceOpen?: boolean
) {
  const [collapsed, setCollapsed] = useState(false);
  const isComplete = totalCount > 0 && confirmedCount === totalCount;
  const [wasComplete, setWasComplete] = useState(isComplete);

  if (isComplete !== wasComplete) {
    setWasComplete(isComplete);
    if (isComplete) setCollapsed(true);
  }

  return {
    isOpen: forceOpen || !collapsed,
    onOpenChange: (open: boolean) => setCollapsed(!open),
  };
}
